module.exports = __webpack_public_path__ + "node_modules/@taxfyle/web-commons/lib/iam/views/WorkspaceSelector/signup-graphic.svg";